import DOMPurify from "dompurify";
// eslint-disable-next-line no-restricted-imports
import parse from "html-react-parser";

export const safelyParseHtml = (str: string) => parse(DOMPurify.sanitize(str));
